<template>
  <SFSkeletonLoader v-if="loading" type="headline" />
  <component
    :is="tag"
    v-else
    :class="[
      HeadlineClass[size],
      isBold ? '!font-bold' : 'font-semibold',
      { uppercase: isUppercase, 'visually-hidden': hidden },
      { 'justify-center': centered },
      generatedFontFamily,
    ]"
    class="flex items-center gap-2 leading-tight"
    data-testid="headline"
    v-bind="$attrs"
  >
    <slot />
    <slot :badge="badge" name="badge">
      <SFHeadlineBadge v-if="badge" :badge="badge" />
    </slot>
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { HeadlineSize, HeadlineTag } from '#storefront-ui'
import { SFHeadlineBadge, SFSkeletonLoader } from '#storefront-ui/components'

const {
  loading = false,
  isUppercase = false,
  hidden = false,
  badge = 0,
  size = HeadlineSize['2XL'],
  tag = HeadlineTag.P,
  isBold = false,
  centered = false,
  fontFamily = undefined,
} = defineProps<{
  loading?: boolean
  isUppercase?: boolean
  hidden?: boolean
  isBold?: boolean
  badge?: number | string
  size?: HeadlineSize
  tag?: HeadlineTag
  centered?: boolean
  fontFamily?: 'geist'
}>()

const HeadlineClass = {
  [HeadlineSize['6XL']]: 'text-6xl',
  [HeadlineSize['5XL']]: 'text-5xl',
  [HeadlineSize['4XL']]: 'text-4xl',
  [HeadlineSize['3XL']]: 'text-3xl',
  [HeadlineSize['2XL']]: 'text-2xl',
  [HeadlineSize.XL]: 'text-xl',
  [HeadlineSize.LG]: 'text-lg',
  [HeadlineSize.MD]: 'text-md',
  [HeadlineSize.BASE]: 'text-base',
  [HeadlineSize.SM]: 'text-sm',
  [HeadlineSize.XS]: 'text-xs',
} as Record<HeadlineSize, string>

const generatedFontFamily = computed(() =>
  fontFamily ? `font-${fontFamily}` : 'font-sans',
)
</script>
